import { useEffect, useState } from "react";
import { ReactComponent as ToggleOn } from "../../assets/icons/toggleOn.svg";
import { ReactComponent as ToggleOff } from "../../assets/icons/toggleOff.svg";

interface ToggleProps {
    className?: string;
    onLabel?: string;
    offLabel?: string;
    isOn?: boolean;
    onToggle?: (event: React.MouseEvent<HTMLButtonElement>, value: boolean) => void;
    disabled?: boolean;
}

const Toggle = ({ className, onLabel = "", offLabel = "", isOn = true, onToggle, disabled }: ToggleProps) => {
    const [toggle, setToggle] = useState(isOn);

    useEffect(() => {
        setToggle(isOn);
    }, [isOn]);

    const handleToggle = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (disabled) return;

        const newState = !toggle;
        setToggle(newState);
        if (onToggle) {
            onToggle(event, newState);
        }
    };

    return (
        <div className="flex gap-2 items-center">
            <button disabled={disabled} onClick={handleToggle} className={`focus:outline-none ${className}`}>
                {toggle ? <ToggleOn /> : <ToggleOff />}
            </button>
            <span className="text-sm text-gray2 whitespace-nowrap">{toggle ? onLabel : offLabel}</span>
        </div>
    );
};

export default Toggle;
